import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, Signal, TemplateRef, ViewChild, ViewContainerRef, computed, signal } from '@angular/core';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatColumnDef, MatHeaderRowDef, MatNoDataRow, MatRowDef, MatTable, MatTableModule } from '@angular/material/table';
import { ISort, ISortEvent } from 'src/app/core/models/sort.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { SafeHtmlPipe } from 'src/app/core/pipes/safe-html.pipe';
import { EmptyListComponent } from '../error/empty-list/empty-list.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { MatIcon } from '@angular/material/icon';
import { SidenavComponent } from "../../../layout/sidenav/sidenav.component";
import { FormBuilder, FormGroup } from '@angular/forms';
import { CrudService } from 'src/app/core/services/crud.service';
import { SidenavService, SidenavSizeType } from 'src/app/core/services/sidenav.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { QueryService } from 'src/app/core/services/query.service';
import { TemplatePortal } from '@angular/cdk/portal';
import { QuerySentrynelService } from 'src/app/core/services/query-sentrynel.service';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { QueryWszService } from 'src/app/core/services/query-wsz.service';
import { CrudWszService } from 'src/app/core/services/crud-wsz.service';
@Component({
    selector: 'app-table-select',
    standalone: true,
    templateUrl: './table-select.component.html',
    styleUrl: './table-select.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        SafeHtmlPipe,
        MatTableModule,
        MatSortModule,
        EmptyListComponent,
        MatIcon,
        SidenavComponent,
        MyButtonComponent,
        MatCheckboxModule
    ]
})
export class TableSelectComponent<TData = any> implements OnInit, AfterContentInit {
  @Input() data: Signal<TData[]> = signal([]);
  @Input() columns: ITableColumn[] = [];
  @Input() visibleColumns: Signal<string[]> = signal([]);
  @Input() sortInitialState?: ISort;
  @Input() rowClick?: (args?: any) => void;
  @Output() sort: EventEmitter<ISortEvent> = new EventEmitter<ISortEvent>();
  @Input() showButtonInsert:boolean=false
  @Input() typeIconInsert:string=''
  @Input() typeTitleInsert:string=''
  @Input() insertFormTitle=''
  @Input() insertForm?: FormGroup;
  @Input() insertFormSize: SidenavSizeType = 'normal';
  @Input() crud?: CrudService<TData> | CrudSentrynelService<TData> | CrudWszService<TData>;
  @Input() queryService!: QueryService<TData> | QuerySentrynelService<TData> | QueryWszService<TData>;
  @Input() onInsertFunction?: (args?: any) => Observable<any>;
  @Input() filterForm?: FormGroup;
  @ViewChild('insertRef') insertRef!: TemplateRef<any>;
  listPageForm: FormGroup;
  
  // this is where the magic happens:
  @ViewChild(MatTable, { static: true }) table?: MatTable<TData>;
  @ContentChildren(MatHeaderRowDef, { descendants: true }) headerRowDefs?: QueryList<MatHeaderRowDef>;
  @ContentChildren(MatRowDef, { descendants: true }) rowDefs?: QueryList<MatRowDef<TData>>;
  @ContentChildren(MatColumnDef, { descendants: true }) columnDefs?: QueryList<MatColumnDef>;
  @ContentChild(MatNoDataRow, { descendants: true }) noDataRow?: MatNoDataRow;
  @Output() insert: EventEmitter<TData> = new EventEmitter<TData>();
  @Output() myDataEvent = new EventEmitter<string>();
  @Output() myIdEditEvent = new EventEmitter();
  singleRowAppoggio:any;
   initialSelection = [];
 allowMultiSelect = true;
selection = new SelectionModel<TData>(this.allowMultiSelect, this.initialSelection);
  // after the <ng-content> has been initialized, the column definitions are available.
  // All that's left is to add them to the table ourselves:
  ngAfterContentInit() {
    this.columnDefs?.forEach(columnDef => this.table?.addColumnDef(columnDef));
    this.rowDefs?.forEach(rowDef => this.table?.addRowDef(rowDef));
    this.headerRowDefs?.forEach(headerRowDef => this.table?.addHeaderRowDef(headerRowDef));
    if (this.noDataRow) {
      this.table?.setNoDataRow(this.noDataRow);
    }
  }
  hasCrud = computed(() => {
    return this.crud !== undefined
  })
  defaultHeaderClass = 'border-bottom-1 border-500 text-xs'
  constructor (
    private readonly fb: FormBuilder,
    public sidenavService: SidenavService,
    private vcf: ViewContainerRef,
    private router: Router
  ) {
    this.listPageForm = this.fb.group({
      search: this.fb.control('', []),
      filter: this.filterForm
    })
  }



  ngOnInit(): void {
  
    if (this.visibleColumns().length === 0) {
      this.visibleColumns().push(...this.columns.filter((column: ITableColumn) => column.visible === undefined || column.visible === true).map((column: ITableColumn) => column.name));
      if(this.showButtonInsert){
        this.visibleColumns().push('conditionalButton');
      }
     
    }

   if(!this.visibleColumns().includes( 'selectElementt')){
    this.visibleColumns().push('selectElementt');
   }
  }
  emitData(row:any) {
    this.myDataEvent.emit(row);
    this.singleRowAppoggio=row
  }
  handleSortEvent(event: Sort) {
    this.sort.emit({
      active: event.active,
      direction: event.direction,
    })
  }

  onRowClick(row: any) {
    if (this.rowClick) {
      this.rowClick(row);
    }
  }

  getList() {
    this.queryService?.get({ pageable: this.queryService?.pageable(), sort: this.queryService?.sort(), search: this.queryService?.search(), filters: this.queryService.filters() });
  }
  onInsertClick(row:any, templateRef: TemplateRef<any>) {
 
    this.emitData(row)
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal, 'end', this.insertFormSize);
    if (this.onInsertFunction) {
      this.onInsertFunction();
    }
  }
  onSaveClick() {
    if (this.insertForm?.valid) {
    
      this.crud?.save(this.insertForm?.value).subscribe({
        next: (modelValue) => {
          this.sidenavService.clearContents();
          this.insert.emit(modelValue);
          if (this.onInsertFunction) {
            this.onInsertFunction(modelValue)
          } else {
            setTimeout(() => {
              this.getList();
            }, 0);
          }
        }
      });

      this.emitData(this.singleRowAppoggio)
    }
  }
  getStyles(element: any, column: ITableColumn): { [key: string]: string } | string {
    if (column.styles && typeof column.styles === 'function') {
      return column.styles(element);
    }
    return '';
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data().length;
    return numSelected == numRows;
  }
  
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
 
    this.isAllSelected() ?
        this.selection.clear() :
        this.data().forEach(row => this.selection.select(row));
    
    this.checkClicked()
  }

  checkClicked(){
 
    this.myIdEditEvent.emit(this.selection.selected)
  }

  ngOnDestroy(){
    var index = this.visibleColumns().indexOf("selectElementt");
    if (index !== -1) {
      this.visibleColumns().splice(index, 1);
    }
  }
}
